import * as React from 'react'
import MUIList from '@mui/material/List'

const List = (props) => <MUIList {...props} />

export default List
